/*
	Definition:
	This plugin will make a HTML select component into a list of checkboxes handling multiselect etc.

	Example for HTML SELECT:
		<select class="box1">
			<option value="1" data-selected="true">slide 1</option>
			<option value="2">slide 2</option>
			<option value="3" data-checked="true">slide 3</option>
		</select>

		$('select.box1')
			.DUIsmartSelectBox({
				'filter':true,
				'checkable': false,
				'height':340,
				'width':330
			});
	
	Parameters:
		name: type [default value] - description

		filter: boolean [false] - defines if a filter box should be visible.
		checkable: boolean [false] - defines if checkboxes should be available
		height: int [142] - defines the height
		maxHeight: int [null] - defines the maxHeight of the expanded panel in singleMode
		width: int [160] - defines the width. Set to 'auto' for dynamic, i.e. no css width is set
		dropdownclass: string ['DUIsmartSelectBoxDropDown'] - CSS Class for option list
		filterclass: string ['DUIsmartSelectBoxFilter'] - CSS Class for filter textbox
		singleMode: boolean [false] - defines if the filter box should look like a select box (single line)
		singleSelect: boolean [false] - defines if only a single item can be selected at a time
		numbering: boolean [false] - defines if numbers should be displayed before the text in the list
		customCheckbox: JSON - defines a set of icons that can be used to replace the checkbox states
			'enabled' - enable custom checkbox states
			'def' - default checkbox state
			'checked' - checked checkbox state
			'disabled' - disabled checkbox state
			'hover' - hover checkbox state
		editable: boolean [false] - defines if the text rows are editable (fires "edited" event)
		editableIcon: string [] - defines which icon to use to indicate editing
		tooltip: string [] Text to display as tooltip when hovering the selectbox. Rendered as html 'title' attribute.
		editTooltip: string ['Edit'] - Text to display as tooltip on the edit buttons in the list.
		editOriginalValue: string [] Text that should be removed when editing, if textbox only contain that text.
		filterTooltip: string [] Text that is displayed as tooltip when hovering the filter box.
		sorting: boolean [false] - Defines if sorting up/down buttons should be visible, which allows sorting in selectbox and original SELECT
		textWrap: boolean [false] - defines if the text should be wraped (also auto-enables tooltip on hover) like normal SELECT


	Predefined states:
		"checkable": Use the data-checkable="false" attribute to define that a row is not checkable.
		"checked": Use the data-checked="true" attribute.
		"selected": Use the data-selected="true" attribute.
		"checkedDisabled": Use the data-checkedDisabled="true" attribute. (disables the checkbox)
		"selectDisabled": Use the data-selectDisabled="true" attribute. (disables the select )

	Events:
		"selected" - Is fired when a row is selected/unselected.
		"checked" - Is fired when a row is checked/unchecked. Carries two parameters [evt, @value, boolIsChecked]
		"edited" - Is fired when a row text is edited. Carries two parameters [evt, @value, text()]
		"movedUp" - Is fired when one or more rows are moved up. Carries one parameter. [evt.list]. array of row numbers 0...n
		"movedDown" - Is fired when one or more rows are moved down. Carries one parameter. [evt.list]. array of row numbers n...0

	Methods:
		"select" - $('select.box1').DUIsmartSelectBox("select", Parameter1); - Selects all items in the list that is in index array Parameter1
		"selected" - $('select.box1').DUIsmartSelectBox("selected"); - returns a list of selected items.
		"checked"  - $('select.box1').DUIsmartSelectBox("checked"); - returns a list of checked items.
		"update" - $('select.box1').DUIsmartSelectBox("update"); - redraws the selectbox with new items (currently full rebind!)
		"destroy" - $('select.box1').DUIsmartSelectBox("destroy"); - removes the selectbox and restores the original element.


	Event + get selected items example:
	$('select.box1').live('selected', function(){
		var x = $(this).DUIsmartSelectBox('selected');
		alert('Selected: '+x);
	})

*/

window.MOUSE_STATE_UP = true;
window.isMac = navigator.appVersion.indexOf("Mac") !== -1;
(function($){

  var methods = {
    init : function( options ) { 
        // default options
        var settings = $.extend({
            'filter' : false,
            'height' : 142,
            'width'  : 160,
            'checkable': false,
            'dropdownclass' : 'DUIsmartSelectBoxDropDown',
            'filterclass' : 'DUIsmartSelectBoxFilter',
            'singleMode' : false,
            'numbering' : false,
            'singleSelect' : false,
            'customCheckbox' : {
				'enabled' : false,
				'def' : '',
				'checked' : '',
				'disabled' : '',
				'hover' : ''
			},
			'editable' : false,
			'editableIcon' : '',
			'tooltip': '',
			'editTooltip': '',
			'filterTooltip' : '',
			'sorting' : false,
			'textWrap' : false
        }, options);
        //save settings
        methods.settings = settings;

		//Handle each SELECT element
		$(this).each(function(){
			function uniqeid(){
				var newDate = new Date;
				return newDate.getTime();
			}

			function insertFilter(HTMLCLASS){
				var filterWidth = (settings.width != 'auto') ? 'width:'+parseInt(settings.width-4,10)+'px;' : '';
				var b64 = [];

				b64.push('data:image/png;base64,');
				b64.push('iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEUAAACSkpKSkpKSkpKSkpKS');
				b64.push('kpKSkpKSkpKSkpKSkpKuQGvSAAAACXRSTlMAEEBQcICfr8+H2gE6AAAARklEQVR42p3OSw4AIQgD');
				b64.push('UOsH2vtfWKOQGbd20/SFBeUttZ/uLWCIWGXyPLEl8M2fMHfKvUHJ7k2GxHbgJy47PAJaPlbLUybK');
				b64.push('8AF9OjB3AQAAAABJRU5ErkJggg==');

				sbHTML.push('<div class="'+HTMLCLASS+'_FilterBox" style="position:relative"><input type="text" title="'+settings.filterTooltip+'" autocomplete="off" autocapitalize="off" autocorrect="off" style="font-size:12px;height:16px;padding:2px;margin-bottom:1px;'+filterWidth+'background-image: url('+b64.join('')+');background-repeat: no-repeat;border: 1px solid #CCC;background-position:'+ (settings.width-18) +'px center;" class="'+settings.filterclass+'"/><div class="'+HTMLCLASS+'_FilterBoxClear" style="cursor:pointer;height:16px;width:16px;top:2px;position:absolute;right:0;background-color:#fff;filter:alpha(opacity=0);opacity:0;z-index:10;"></div></div>');
			}

			var oThis = $(this);
			var sbHTML = [];
			var sbSelectedText = [];
			var HTMLID = 'DUIsmartSelectBox_'+uniqeid()+'_'+Math.floor(Math.random()*100);
			var DUIOBJECT = ''; //the component's main node
			var moveSelPivot = null;


			//handle singleMode
			var ddCSS = '';
			var widthSingleMode = (settings.width != 'auto') ? 'width:'+parseInt(settings.width-4,10)+'px;' : '';
			if( settings.singleMode ){
				ddCSS = 'display:none;position:absolute;margin-top:0px;';
			}
			sbHTML.push('<div class="DUIsmartSelectBox" id="'+HTMLID+'" title="'+ settings.tooltip +'" style="font-size:12px;display: inline-block;">');
			if( settings.singleMode ){
				sbHTML.push('<div style="padding:2px;border:1px solid #ccc;cursor:default;'+widthSingleMode+'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" class="DUIsmartSelectBox_SingleButton">(No Selection)</div>');
			}
				//selectbox + filter container
				sbHTML.push('<div class="DUIsmartSelectBox_SelectBoxContainer" style="'+ddCSS+'">');

				if( settings.sorting && !settings.singleMode && !settings.filter ){
					sbHTML.push('<div style="width: 16px;border: 1px solid #CCC;float: left;height: 36px;margin-right: -1px;-moz-user-select: none;-webkit-user-select: none;-ms-user-select: none;color:#000;" onselectstart="return false">');
						sbHTML.push('<div class="DUIsmartSelectBox_sortUp" style="cursor:pointer;background-image: -moz-linear-gradient(center top , #fff, #ccc);background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#ccc));filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=#ffffffff, endColorstr=#ffcccccc);border-bottom:1px solid #888;text-align:center;line-height:18px;font-size:12px;" onmouseover="this.style.color=\'#6ACE00\'" onmouseout="this.style.color=\'\'">&#9650;</div>');
						sbHTML.push('<div class="DUIsmartSelectBox_sortDown" style="cursor:pointer;background-image: -moz-linear-gradient(center top , #fff, #ccc);background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#ccc));filter: progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=#ffffffff, endColorstr=#ffcccccc);text-align:center;border-bottom:1px solid #999;line-height:17px;font-size:12px;" onmouseover="this.style.color=\'#6ACE00\'" onmouseout="this.style.color=\'\'">&#9660;</div>');
					sbHTML.push('</div>');
				}

				if( settings.filter && !settings.singleMode ) {
					insertFilter('DUIsmartSelectBox');
				}
				var adjustedWidth = settings.width;
				if( settings.width < 50 ) adjustedWidth = 75;
				if( settings.sorting ) adjustedWidth = parseInt(adjustedWidth-25);

				var widthCSS = (settings.width != 'auto') ? 'width:'+adjustedWidth+'px;' : '';
				var heightCSS = (settings.height != 'auto') ? 'height:'+settings.height+'px;' : '';

				if( settings.singleMode && settings.maxHeight ) {
					heightCSS = 'min-height:'+ settings.height +'px;max-height:'+ settings.maxHeight +'px;*height:'+ settings.maxHeight +'px;';
				}

				sbHTML.push('<div style="'+ heightCSS + widthCSS +'overflow-x:hidden;overflow-y:auto;border:1px solid #d2d2d2;-webkit-border-radius: 4px;border-radius: 4px;background-color:#fff;" class="DUIsmartSelectBox_SelectBox '+settings.dropdownclass+'">');

				oThis.children().each(function(ind){
					var iSelected = ($(this).attr('data-selected') == 'true');
					var iSelectDisabled = ($(this).attr('data-selectDisabled') == 'true');

					var isNotCheckable = ($(this).attr('data-checkable') == 'false');
					var iChecked = ($(this).attr('data-checked') == 'true');
					var iCheckedDisabled = ($(this).attr('data-checkedDisabled') == 'true');

					var selStyle = (iSelected) ? 'background-color:#29abe2;color:#fff;' : ''; 
						selStyle += (iSelectDisabled) ? 'background-color:#f2f2f2;color:#ccc;' : ''; 
					var selAttr = (iSelectDisabled) ? ' data-selectDisabled="true"' : '';

					var numStyle = (settings.numbering) ? 'padding-left:34px;' : '';

					var chkStr = (iChecked) ? ' checked="checked"' : ''; 
						chkStr += (iCheckedDisabled) ? ' disabled="disabled" data-checkedDisabled="true"' : ''; 


					var wrapStyle = (settings.textWrap) ? 'white-space:nowrap;' : '';
					var tooltipAttr = (settings.textWrap) ? ' title="'+$(this).text()+'"' : '';


					if( iSelected ){
						sbSelectedText.push($(this).text());
					}

					sbHTML.push('<div data-value="'+$(this).val()+'" style="cursor:default;user-select:none;-moz-user-select:none;-webkit-user-select:none;padding-left:0.5em;line-height:20px;'+selStyle+''+numStyle+''+wrapStyle+'"'+selAttr+''+tooltipAttr+'>');
						if( settings.numbering ){
							sbHTML.push('<input type="text" autocomplete="off" style="margin:0 4px 0 0;font-weight:bold;color:inherit;float:left;border:0;padding:2px 2px 0 0;background-color:transparent;width:23px;height:15px;focus:0;text-align:right;font-size:1.1em;margin-left:-30px;" onfocus="this.blur()" value="'+parseInt(ind+1,10)+'"/>');
						}
						if( settings.checkable ){
							if( !isNotCheckable ){
								if( settings.customCheckbox.enabled == false ){
									sbHTML.push('<input type="checkbox" style="margin:0;float:right"'+chkStr+'/>');
                               } else {
                                    var attrs = [], icon = settings.customCheckbox.def, CSSclass = "DUIsmartSelectBoxCheckboxUnchecked";

                                    iSelected && attrs.push('data-selected="true"');
                                    iSelectDisabled && attrs.push('data-selectDisabled="true"');
                                    iChecked && attrs.push('data-checked="true"');
                                    iCheckedDisabled && attrs.push('data-checkedDisabled="true"');

                                    if (iChecked){
                                       icon = settings.customCheckbox.checked;
                                       CSSclass = "DUIsmartSelectBoxCheckboxChecked";
                                    } else if (iCheckedDisabled) {
                                       icon = settings.customCheckbox.disabled;
                                       CSSclass = "DUIsmartSelectBoxCheckboxDisabled";
                                    }

                                   sbHTML.push('<img class="DUIsmartSelectBox_CheckBox '+CSSclass+'" ' + attrs.join(' ') + ' style="margin-top:2px;float:right" src="' + icon + '"/>');
								}
							}
						}
							if( settings.editable == true && settings.checkable == false ){
								sbHTML.push('<img src="'+settings.editableIcon+'" class="DUIsmartSelectBox_TextEdit" title="'+ settings.editTooltip +'" style="width:16px;height:16px;cursor:pointer;margin-top:2px;float:right"/>');
							}
						sbHTML.push($(this).text());
					sbHTML.push('</div>');
				});

				sbHTML.push('</div>');

				if( settings.filter && settings.singleMode ){
					insertFilter('DUIsmartSelectBox');
				}

				sbHTML.push('</div>');

			sbHTML.push('</div>');


			$(sbHTML.join('')).insertAfter(oThis);
			DUIOBJECT = $('#'+HTMLID);

			var selectbox = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);

			//set text selections
            $('.DUIsmartSelectBox_SingleButton', DUIOBJECT).text(sbSelectedText.join(', '));

			//FILTER HANDLING
			if( settings.filter ){
				$('.DUIsmartSelectBox_FilterBoxClear',DUIOBJECT).click(function(){
					$('.DUIsmartSelectBox_FilterBox',DUIOBJECT).children('input').val('').keyup();
				});
				$('.DUIsmartSelectBox_FilterBox',DUIOBJECT).children('input').keyup(function(){
					var keyword = $(this).val();

                    selectbox.children().hide();
                    //Check for matches
                    //Keyword variations: keyWoRd (original), KEYWORD, keyword, Keyword
                    var multiple = keyword.split(' ');
                    var multipleLen = multiple.length;
                    var query = new Array();
                    var i = 0;

                    //Handle multiple keywords, using OR          
                    for( i;multipleLen>i;i++ ){
                        if( multiple[i].length < 1 ) continue; //check for empty entry

                        query.push(':contains("'+multiple[i]+'")');
						query.push(':contains("'+multiple[i].toUpperCase()+'")');
						query.push(':contains("'+multiple[i].toLowerCase()+'")');
						query.push(':contains("'+multiple[i].substr(0, 1).toUpperCase() + multiple[i].substr(1).toLowerCase()+'")'); 
                    }

					if(query.length > 0) {
						selectbox.children().filter(function(index) {
							var q = query.join(', ');
							var retVal = ($(this).filter(q).length > 0);
							if(!retVal && settings.numbering) {
								retVal = ($.inArray($(this).children(':text').val(), multiple) > -1);
							}
							return retVal;
						}).show();
					} else {
						selectbox.children().show();
					}
				})
				.mousedown(function(evt) {
					evt.stopPropagation();
				})
				.mouseup(function(evt) {
					evt.stopPropagation();
				})
				.click(function(evt) {
					evt.stopPropagation();
				});
			}

			if( settings.sorting ){
				//Allow the user to use up/down buttons
				$('.DUIsmartSelectBox_sortUp',DUIOBJECT)
				.click(function(){
					var box = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);
					var retEvt = [];
					box.children().each(function(ind){
							if( $(this)[0].style.backgroundColor != ''){
								$(this).insertBefore($(this).prev());
								oThis.children().eq(ind).insertBefore(oThis.children().eq(ind).prev());
								retEvt.push(ind);
						}
					});

					if( retEvt.length > 0 ){
						oThis.trigger({
							type: "movedUp",
							list: retEvt
						})
					}
				});

				$('.DUIsmartSelectBox_sortDown',DUIOBJECT)
				.click(function(){
				var box = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);
				var retEvt = [];
				var len = box.children().length-1;
				var iterThis, selectThis;

				while(len>=0){
					iterThis = box.children().eq(len);
					selectThis = oThis.children().eq(len);
					if( iterThis[0].style.backgroundColor != ''){
						iterThis.insertAfter(iterThis.next());
						selectThis.insertAfter(selectThis.next());
						retEvt.push(len);
					}
					len--;
				}

					if( retEvt.length > 0 ){
						oThis.trigger({
							type: "movedDown",
							list: retEvt
						})
					}
				})
			}

			//bind events
			$('div[data-value]',selectbox)
				.mouseup(function(evt){
					evt.stopPropagation();
					if(!MOUSE_STATE_UP){
						MOUSE_STATE_UP = true;
						oThis.trigger('selected');
					}
				})

			if( settings.customCheckbox.enabled != false ){
			$('.DUIsmartSelectBox_CheckBox',DUIOBJECT)
				.mouseover(function(){
					if( settings.customCheckbox.hover && $(this).attr('data-checkedDisabled') != 'true' ){
						if(this.src.split('/').pop() != settings.customCheckbox.checked.split('/').pop())
							this.src = settings.customCheckbox.hover;
							$(this).attr('class','DUIsmartSelectBox_CheckBox DUIsmartSelectBoxCheckboxHover');
					}
				})
				.mouseout(function(){
					if( settings.customCheckbox.hover && $(this).attr('data-checkedDisabled') != 'true' ){
						if(this.src.split('/').pop() != settings.customCheckbox.checked.split('/').pop())
							this.src = settings.customCheckbox.def;
							$(this).attr('class','DUIsmartSelectBox_CheckBox DUIsmartSelectBoxCheckboxUnchecked');
					}
				})
				.click(function(evt){
					evt.stopPropagation();
					if( $(this).attr('data-checkedDisabled') != 'true' ){
						if(this.src.split('/').pop() == settings.customCheckbox.checked.split('/').pop()){
							this.src = settings.customCheckbox.def;
							$(this).attr('class','DUIsmartSelectBox_CheckBox DUIsmartSelectBoxCheckboxUnchecked');
							$(this).removeAttr('data-checked');
						} else {
							this.src = settings.customCheckbox.checked;
							$(this).attr('class','DUIsmartSelectBox_CheckBox DUIsmartSelectBoxCheckboxChecked');
							$(this).attr('data-checked','true');
						}
					}
				})
			}

			if( settings.editable == true ){
				/* Handle text editing */
				$('.DUIsmartSelectBox_TextEdit',DUIOBJECT)
					.click(function(evt){
						evt.stopPropagation();
						$(this).hide();
						var inputWidth = parseInt(settings.width,10) -40;
						var inputDefaultText = ($(this).parent().text() == settings.editOriginalValue)? '' : $(this).parent().text();
						$(this).parent().append('<input class="textEdit" data-original="'+$(this).parent().text()+'" value="'+inputDefaultText+'" title="" style="width:'+inputWidth+'px;padding:1px; margin:0;font-size:12px;"/>');
						var cnodes = $(this).parent()[0].childNodes;
						for( var i=0; i<cnodes.length;i++){
							if( cnodes[i].nodeType == 3 ){
								cnodes[i].nodeValue = '';
							}
						}

						$(this).parent().children('.textEdit')
							.focus()
							.click(function(evt){
								evt.stopPropagation();
							})
							.keydown(function(evt){
								var code = (evt.keyCode ? evt.keyCode : evt.which);
								if(code == 13) {
									evt.preventDefault();
									evt.stopImmediatePropagation();
									$(this).blur();
								}
							})
							.blur(function(){
								var newVal = ($(this).val().trim() == '') ? settings.editOriginalValue : $(this).val();
								for( var i=0; i<cnodes.length;i++){
									if( cnodes[i].nodeType == 3 ){
										cnodes[i].nodeValue = newVal;
									}
								}
								if( $(this).attr('data-original') != newVal ){
									//fire event
									var retValue = [];
									retValue.push($(this).parent().attr('data-value'));
									retValue.push(newVal);
									retValue.push(settings.editOriginalValue);
									oThis.trigger('edited', retValue);
								}

								$(this).parent().children('.DUIsmartSelectBox_TextEdit').show();
								$(this).remove();
							});
					});
			}

			$('.DUIsmartSelectBox_SingleButton',DUIOBJECT)
				.click(function(evt){
					evt.stopPropagation();
					var el = $('.DUIsmartSelectBox_SelectBoxContainer',DUIOBJECT);
					var reqPosX = parseInt($(this).offset().top + el.height(),10);
					var avaPosX = parseInt($(window).height() + $(window).scrollTop(),10);
					var marginTopDiff = (reqPosX > avaPosX) ? -parseInt(el.height()-1,10) : 0;
					el.css('margin-top',marginTopDiff+'px');
					$('.DUIsmartSelectBox_FilterBox',DUIOBJECT).css('margin-top',marginTopDiff+'px');
					el.toggle();
				})
				.hover(
					function(){
						$(this).css('background-color','#f7f7f7');
					},
					function(){
						$(this).css('background-color','');
					}
				);

			$('.DUIsmartSelectBox_SelectBox',DUIOBJECT).click(function(evt) {
				evt.stopPropagation();
			});

			$('.DUIsmartSelectBox_SelectBox',DUIOBJECT).bind('selectstart dragstart', function(evt) {
				return false;
			});

			$('.DUIsmartSelectBox_SelectBox',DUIOBJECT).bind('mouseleave', function(evt) {
				if (MOUSE_STATE_UP || settings.singleSelect || moveSelPivot === null) return;
				
				var top =  $(this).offset().top;
				var bottom = top + $(this).outerHeight();
				var moveSelIndex = $(moveSelPivot).index();
				var currSelIndex;
				var selectableEls = $(this).children();

				if (evt.pageY <= top) 			currSelIndex = selectableEls.first().index();
				else if (evt.pageY >= bottom) 	currSelIndex = selectableEls.last().index();
				else return;

				selectableEls.each(function(index) {
					var s = this.style;
					var iterDisabled = $(this).attr('data-selectDisabled') == 'true' || s.display == 'none';
					var inRange = moveSelIndex === index ||
								(currSelIndex > moveSelIndex && moveSelIndex <= index && index <= currSelIndex) ||
								(currSelIndex < moveSelIndex && moveSelIndex >= index && index >= currSelIndex);

					if (inRange && !iterDisabled){
							s.color = '#fff';
							s.backgroundColor= '#29abe2';
					} else {
						s.color = '';
							s.backgroundColor= '';
					}
				});
			});

			$('.DUIsmartSelectBox_SelectBox',DUIOBJECT).children().each(function(){
				var _this = $(this)[0];
				//IE disable text selection
				$(_this).bind('selectstart dragstart', function(evt) { return false; });

				$(_this).mouseover(function(){
					if(!MOUSE_STATE_UP && !settings.singleSelect && moveSelPivot !== null){
						var moveSelIndex = $(moveSelPivot).index();
						var currSelIndex = $(this).index();

						$(this).parent().children().each(function(index) {
							var s = this.style;
							var iterDisabled = $(this).attr('data-selectDisabled') == 'true' || this.style.display == 'none';
							var inRange = moveSelIndex === index ||
										(currSelIndex > moveSelIndex && moveSelIndex <= index && index <= currSelIndex) ||
										(currSelIndex < moveSelIndex && moveSelIndex >= index && index >= currSelIndex);

							if (inRange && !iterDisabled){
								s.color = '#fff';
								s.backgroundColor= '#29abe2';
							} else {
								s.color = '';
								s.backgroundColor= '';
							}
						});
					}
				});

				$(_this).mouseup(function(evt){
					evt.stopPropagation();
					MOUSE_STATE_UP = true;
					moveSelPivot = null;
					
					if( evt.target.nodeName == 'INPUT' || evt.target.nodeName == 'IMG' ){
						if( $(evt.target).hasClass('DUIsmartSelectBox_CheckBox') ){
							setTimeout(function(){
								var retValue = [];
								retValue.push($(evt.target).parent().attr('data-value'));
								retValue.push(($(evt.target).attr('data-checked') == 'true'));
								oThis.trigger('checked', retValue);
							},1);
						}
						return;
					}
					if(evt.target.nodeName == 'DIV') {
						evt.stopPropagation();
					} else {
						oThis.trigger('selected');
					}
					if( settings.singleMode ){
						var DUIOBJECT = oThis.next();
						var selectbox = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);
						var retVal = [];
						var retValData = [];
						selectbox.children().each(function(){
							if( $(this)[0].style.backgroundColor != ''){
								retVal.push($(this).text());
								if(settings.numbering) {
									retValData.push($(this).attr('data-value'));
								}
							}
						});

						if(settings.numbering) {
							for(var index=0;index < retVal.length; index++) {
								retVal[index] = (retVal[index].length > 0) ? (retValData[index]) + ' - '+ retVal[index] : retValData[index];
							}
						}

						$('.DUIsmartSelectBox_SingleButton',DUIOBJECT).text(retVal.join(', '))
						$('.DUIsmartSelectBox_SingleButton',DUIOBJECT).click();
					}
				});

				$(_this).mousedown(function(evt){
					evt.stopPropagation();
					if( evt.target.nodeName == 'INPUT' || evt.target.nodeName == 'IMG' ){
						return;
					}

					//shift select (select all elements within a range)
					if(MOUSE_STATE_UP && evt.shiftKey && !settings.singleSelect ){
						var currSelIndex = $(_this).index();
						var firstSelIndex = -1;
						var lastSelIndex = -1;
						//CALC index
						$(this).parent().children().each(function(){
							var oThis = $(this);
							if( oThis[0].style.backgroundColor == 'rgb(41, 171, 226)' || oThis[0].style.backgroundColor == '#29abe2' ){
								if( firstSelIndex < 0 ){
									firstSelIndex = oThis.index();
								}
								lastSelIndex = oThis.index();
							}
						});

						//if new select is below current select
						if( currSelIndex > lastSelIndex ){
							$(_this).parent().children().each(function(ind){
								var iterThis = $(this)[0];
								var iterDisabled = $(this).attr('data-selectDisabled') == 'true' || iterThis.style.display == 'none';
								if( ind <= currSelIndex && ind >= lastSelIndex && !iterDisabled ){
									iterThis.style.color = '#fff';
									iterThis.style.backgroundColor = '#29abe2';
								}
							});
						}

						//if new select is above current select
						if( currSelIndex < firstSelIndex ){
							$(_this).parent().children().each(function(ind){
								var iterThis = $(this)[0];
								var iterDisabled = $(this).attr('data-selectDisabled') == 'true' || iterThis.style.display == 'none';
								if( ind >= currSelIndex && ind <= firstSelIndex && !iterDisabled ){
									iterThis.style.color = '#fff';
									iterThis.style.backgroundColor = '#29abe2';
								}
							});
						}

						oThis.trigger('selected');
						return;
					}

					//Deselect all others
					if( MOUSE_STATE_UP && !((!isMac && evt.ctrlKey) || (isMac && evt.metaKey)) || settings.singleSelect ){
						$(this).parent().children().each(function(ind){
							var thisNode = $(this)[0];
							var iterDisabled = $(this).attr('data-selectDisabled') == 'true';
							if(!iterDisabled){
								if( thisNode.style.backgroundColor != '' ){
									$(thisNode).attr('data-tmpselected', 'true');
								} else {
									if( $(thisNode).attr('data-tmpselected') !== 'true' ){
										thisNode.removeAttribute('data-tmpselected');
									}
								}
								thisNode.style.backgroundColor = '';
								thisNode.style.color = '';
							}
						});
					}

					//ctrl select (select one more item)
					MOUSE_STATE_UP = false;
					if ($(_this).attr('data-selectDisabled') != 'true') {
						if (_this.style.backgroundColor == '' && ( $(_this).attr('data-tmpselected') != 'true' || settings.singleSelect) ){
							_this.style.color = '#fff';
							_this.style.backgroundColor = '#29abe2';
						} else {
							_this.style.color = '';
							_this.style.backgroundColor = '';
						}						
					}
					
					$(_this).parent().find('div[data-tmpselected]').removeAttr('data-tmpselected');

					if (!settings.singleSelect) {
						moveSelPivot = this;

						$(document).unbind('mouseup.DUIsmartSelectBox')
							.bind('mouseup.DUIsmartSelectBox', function() {
								MOUSE_STATE_UP = true;
								moveSelPivot = null;
								oThis.trigger('selected');
								$(document).unbind('mouseup.DUIsmartSelectBox');
						});
					}
				});
			});

			oThis.addClass('DUIsmartSelectBox').hide();
		}) //end handle multiple SELECTs
    },
    select : function(selections){
		var oThis = $(this);
        var DUIOBJECT = oThis.next();
		var selectbox = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);
		var selectedTexts = '';
		selectbox.children('DIV').css('background-color', '');
		selectbox.children('DIV').css('color', '#000');
		if( oThis.hasClass('DUIsmartSelectBox') ){
			selectbox.children('DIV').each(function(index) {
				var itmValue = $(this).attr('data-value');
				if($.inArray(parseInt(itmValue), selections) > -1){
					$(this).css('background-color', 'rgb(41, 171, 226)');
					//rgb(41, 171, 226)
					$(this).css('color', '#fff');
					if(methods.settings.numbering)
						selectedTexts += ',' + (index+1);
						if($(this).text().length > 0)
							selectedTexts += ' - '+ $(this).text();
					else
						selectedTexts += ',' + $(this).text();
				}
			});
			selectedTexts = selectedTexts.substr(1);
			if(DUIOBJECT.children(':first').hasClass('DUIsmartSelectBox_SingleButton'))
				$('.DUIsmartSelectBox_SingleButton',DUIOBJECT).text(selectedTexts);
		}
    },
	selected : function( ){
		var oThis = $(this);
		var DUIOBJECT = oThis.next();
		var selectbox = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);
		var retVal = [];
		if( oThis.hasClass('DUIsmartSelectBox') ){
			selectbox.children('DIV').each(function(index){
				var color = $(this).css('background-color');
				if (color == 'rgb(41, 171, 226)' || color == 'rgb(51, 102, 153)' || color == '#29abe2')
					retVal.push($(this).attr('data-value'));
			});
			return retVal;
		}
    },
    checked : function( ){
		var oThis = $(this);
		var DUIOBJECT = oThis.next();
		var selectbox = $('.DUIsmartSelectBox_SelectBox',DUIOBJECT);
		var retVal = [];
		if( oThis.hasClass('DUIsmartSelectBox') ){
			selectbox.children().each(function(){
				var inp = $(this).children('input, img');
				if( inp.is(':checked') || inp.attr('data-checked') == 'true' ){
					retVal.push($(this).attr('data-value'));
				}
			});
			return retVal;
		}
    },
    update : function( ) { 
		/* Does not take previously checked or selected into consideration */
		var oThis = $(this);
		if( oThis.hasClass('DUIsmartSelectBox') ){
			oThis.next().remove(); //smart container
			oThis.removeClass('DUIsmartSelectBox')
			oThis.DUIsmartSelectBox(methods.settings);
		}
    },
    destroy : function( ){
		var oThis = $(this);
		if( oThis.hasClass('DUIsmartSelectBox') ){
			oThis.next().remove(); //smart container
			oThis.removeClass('DUIsmartSelectBox')
			oThis.show();
		}
    }
  };


	$.fn.DUIsmartSelectBox = function( method ){
		if( methods[method] ){
			return methods[ method ].apply( this, Array.prototype.slice.call ( arguments, 1 ));
		} else if ( typeof method === 'object' || !method ){
			return methods.init.apply( this, arguments );
		}
	}
})(jQuery);
